<template>
  <v-container class="bg-azul">
    <v-row id="seccionPlanes" class="header-row text-center">
      <v-col cols="12" md="10" lg="8" class="mx-auto">
        <h2 class="header-title">
          Elige el plan ideal para ti
        </h2>

        <p class="header-subtitle grey--text">
          Filtra según tus necesidades
        </p>
      </v-col>
    </v-row>
    <v-row justify="center" class="my-2">
      <!-- Filtros -->
      <v-col cols="12" md="10" class="mb-2">
        <v-row dense>
          <v-col cols="6" sm="3">
            <v-select v-model="filtros.tipo" :items="['Todos', 'Individual', 'Familiar']" label="Tipo de plan" outlined
              dense />
          </v-col>
          <v-col cols="6" sm="3">
            <v-select v-model="filtros.edad" :items="['Todos', 'General', 'Mayores de 50']" label="Edad" outlined
              dense />
          </v-col>
          <v-col cols="12" sm="6">
            <v-select v-model="filtros.hospital" :items="['Todos', 'Red General', 'La Bene']" label="Red de atención"
              outlined dense />
          </v-col>
        </v-row>
      </v-col>

      <!-- Planes filtrados -->
      <v-col v-for="plan in planesFiltrados" :key="plan.id" cols="12" sm="4" md="4" class="d-flex">
        <v-card class="gradient-card elevation-10 rounded-xl pa-2 flex-grow-1 white--text">
          <!-- Título del plan y etiqueta -->
          <v-card-title class="justify-center text-center grey--text flex-column">
            <div class="headline font-weight-bold mb-1">{{ plan.title }}</div>
            <!-- <v-chip v-if="plan.destacado" small color="blue lighten-4" text-color="pink darken-3" label>
              ⭐ {{ plan.destacado }}
            </v-chip> -->
          </v-card-title>

          <!-- Precio mensual -->
          <v-card-text class="text-center">
            <div class="price-section mb-3">
              <span class="display-1 font-weight-bold">{{ $formatCurrency(plan.costo) }}</span>
              <div class="caption">Mensual</div>
            </div>

            <ul class="pl-4">
              <li v-for="(item, i) in plan.beneficios" :key="i" class="mb-2 d-flex">
                <!-- Ícono fijo a la izquierda -->
                <v-icon color="success" small class="mr-2 flex-shrink-0">mdi-check-circle</v-icon>

                <!-- Texto que ocupa todo el ancho restante -->
                <span class="body-2 grey--text text--darken-2" style="display: block; flex: 1; word-break: break-word;"
                  v-html="item"></span>
              </li>
            </ul>
          </v-card-text>

          <!-- Botón -->

          <v-card-actions class="justify-center">
            <v-btn text large class="grey--text font-weight-bold" @click="whatsappLink(plan.title)"> <v-icon
                left>mdi-whatsapp</v-icon>Cotizar por WHATSAPP</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'SeccionPlanesComponent',
  data() {
    return {
      filtros: {
        tipo: 'Todos',
        edad: 'Todos',
        hospital: 'Todos',
      },
      planes: [
        {
          id: '1', title: 'Plus Familiar', costo: 1400, tipo: 'Familiar', edad: 'General', hospital: 'Red General',
          beneficios: [
            'Atención de urgencias con cobertura de <b>$65,000 MXN</b> en toda nuestra red hospitalaria',
            'Incluye a tus <b>familiares directos</b> como beneficiarios',
            'Consultas médicas con <b>especialistas</b>: 6 LUC disponibles para ti y los beneficiarios de tu familia',
            'Paquete de consultas médicas con <b>tarifa especial</b> si las agotas antes de la vigencia del plan',
          ]
        },
        {
          id: '2', title: 'La Bene Familiar', costo: 1200, tipo: 'Familiar', edad: 'General', hospital: 'La Bene',
          beneficios: [
            'Atención de urgencias con cobertura de <b>$65,000 MXN</b> en Hospital La Bene San Luis',
            'Incluye a tus <b>familiares directos</b> como beneficiarios',
            'Consultas médicas con <b>especialistas</b>: 6 LUC disponibles para ti y los beneficiarios de tu familia',
            'Paquetes de consultas médicas con <b>tarifa especial</b> si las agotas antes de la vigencia del plan'
          ]
        }, //, destacado: 'Más vendido'
        {
          id: '3', title: 'Plus Individual', costo: 650, tipo: 'Individual', edad: 'General', hospital: 'Red General',
          beneficios: [
            'Atención de urgencias con cobertura de <b>$65,000 MXN</b> en toda nuestra red hospitalaria',
            'Consultas médicas con <b>especialistas</b>: 6 LUC disponibles inmediatamente',
            'Paquete de consultas médicas con <b>tarifa especial</b> si las agotas antes de la vigencia del plan'
          ]
        },
        {
          id: '4', title: 'Plus Individual 50', costo: 1200, tipo: 'Individual', edad: 'Mayores de 50', hospital: 'Red General',
          beneficios: [
            'Diseñado especialmente para quienes tienen más de 50 años',
            'Atención de urgencias con cobertura de <b>$65,000 MXN</b> en toda nuestra red hospitalaria',
            'Consultas médicas con <b>especialistas</b>: 6 LUC disponibles inmediatamente',
            'Paquete de consultas médicas con <b>tarifa especial</b> si las agotas antes de la vigencia del plan'
          ]
        },
        {
          id: '5', title: 'La Bene Individual 50', costo: 1100, tipo: 'Individual', edad: 'Mayores de 50', hospital: 'La Bene',
          beneficios: [
            'Diseñado especialmente para quienes tienen más de 50 años',
            'Atención de urgencias con cobertura de <b>$65,000 MXN</b> en Hospital La Bene San Luis',
            'Consultas médicas con <b>especialistas</b>: 6 LUC disponibles inmediatamente',
            'Paquete de consultas médicas con <b>tarifa especial</b> si las agotas antes de la vigencia del plan'
          ]
        }
      ],
    };
  },
  methods: {
    agregarCarrito(id) {
      localStorage.setItem('NumCarrito', id);
    },
    scrollTo(id) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    },
    whatsappLink(plan) {
      var url = `https://wa.me/${process.env.VUE_APP_BASE_PHONEWHATSWEB}?text=${encodeURIComponent('Hola quisiera una cotización de ')}${plan}`;
      window.open(url, '_blank');
    },
  },
  computed: {
    planesFiltrados() {
      return this.planes.filter(plan => {
        const { tipo, edad, hospital } = this.filtros;
        return (
          (tipo === 'Todos' || plan.tipo === tipo) &&
          (edad === 'Todos' || plan.edad === edad) &&
          (hospital === 'Todos' || plan.hospital === hospital)
        );
      });
    }
  },
};
</script>

<style scoped>
ul {
  padding-left: 1.5em;
}

li {
  margin-bottom: 0.5em;
}

.gradient-card {
  background: linear-gradient(to bottom right, #F5F5F5, #FFFFFF);
  color: black;
}

.fade-in-up {
  animation: fadeInUp 1s ease-out;
}

.price-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@keyframes fadeInUp {
  from {
    transform: translateY(40px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
